import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppNotification } from 'globals/store/app.data';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from '../../components/dialog.confirmDelete.component';
import { Wrapper } from '../../components/wrapper.component';
import { CommonModule } from '@angular/common';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { MatMenuModule } from '@angular/material/menu';
import { TimeZonePipe, ZonedDatePipe } from 'src/app/services/pipes/timezone.pipe';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';

@Component({
    selector: 'app-notifications-list',
    template: `
<tip-text [type]="'tip'" [head]="'Tip:'" [body]="'When you click push, a notification will be sent to all the people currently logged into your app.  All app users will also be able to see all previous notifications from within the app unless dismissed.'"></tip-text>

<div class="notification-grid">
  <div class="hint" *ngIf="!notifications.length">There are no notifications yet</div>
  <ng-container *ngFor="let not of notifications">
    <ng-container  *ngIf="{ 
      sent: not.sentManually || not.sentAutomatically,
      pushing: !not.sentManually && !not.sentAutomatically && now <= not.pushTime + buffer && now >= not.pushTime - buffer,
      scheduled: !not.sentManually && !not.sentAutomatically && now < not.pushTime - buffer,
      pastUnsent: !not.sentManually && !not.sentAutomatically && now >= not.pushTime + buffer
     } as vars">
      <div class="name" (click)="vars.sent ? null : edit.emit(not)">{{ not.title || 'Unnamed Notification' }}</div>
      <div class="push-time">
        <ng-container *ngIf="vars.scheduled">Scheduled push time </ng-container>
        <ng-container *ngIf="vars.sent">{{ not.sentManually ? 'Manually' : 'Automatically' }} Pushed at </ng-container>
        <ng-container *ngIf="!vars.pushing && !vars.pastUnsent">{{ not.pushTime | zonedDatePipe:not.timeZone | date:" hh:mma d MMM" }} {{ not.pushTime | timeZoneAbbreviationPipe:not.timeZone }}</ng-container>
        <ng-container *ngIf="vars.pushing">May be pushing...</ng-container>
        <ng-container *ngIf="vars.pastUnsent">Never pushed</ng-container>
      </div>
      <action-button 
        [disabled]="pushingIds.has(not)" 
        (click)="pushingIds.has(not.id) ? null : pushNotification(not.id)"
        [text]="pushingIds.has(not.id) ? 'PUSHING' : vars.sent ? 'RE-PUSH MANUALLY' : 'PUSH NOW'"
      ></action-button>
      <div class="options-holder">
        <icon [id]="'delete' + not.id" class="view_opt" [matMenuTriggerFor]="viewOptions" matIcon="more_vert"></icon>
        <mat-menu #viewOptions="matMenu" xPosition="before">
          <button mat-menu-item (click)="confirmDelete(not, 'delete' + not.id)">Delete</button>
          <button mat-menu-item *ngIf="!vars.sent" (click)="edit.emit(not)">Edit</button>
        </mat-menu>
      </div>
      <div class="description">{{ not.message }}</div>
    </ng-container>
  </ng-container>
</div>
`,
    styleUrls: ['app-notifications-list.scss'],
    standalone: true,
    imports: [CommonModule, ActionButtonComponent, IconComponent, MatMenuModule, ZonedDatePipe, TipTextComponent, TimeZonePipe],
})
export class AppNotificationsListComponent extends Wrapper<AppNotificationsListComponent> {
  @Input() notifications: AppNotification[] = []
  @Output() edit: EventEmitter<AppNotification> = new EventEmitter()

  buffer = 1000 * 60 // buffer (before and after) scheduled sending time to show message may be sending
  pushingIds = new Set()

  async pushNotification(notificationId: string) {
    this.pushingIds.add(notificationId)
    await this.appService.manuallyPushNotification(notificationId)
    this.pushingIds.delete(notificationId)
  }

  deleteNotification(id: string) {
    this.notifications = this.notifications.filter(n => n.id !== id)
    this.appService.deleteNotification(id);
  }

  async confirmDelete(notification: AppNotification, deleteId: string) {
    const el = document.getElementById(deleteId)
    const rect = el.getBoundingClientRect()
    const data: ConfirmDeleteData = { 
      rect, 
      title: 'Delete Notification', 
      para: 'This cannot be undone', 
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.deleteNotification(notification.id)
  }

}

